import { createContext, useContext } from 'react';

const InteractionLockContext = createContext(false);

export const InteractionLock = ({ lock, children }) => (
  <InteractionLockContext.Provider value={lock}>{children}</InteractionLockContext.Provider>
);

export const useInteractionLock = () => useContext(InteractionLockContext);
